<script>
    import ResultsChart from './ResultsChart.svelte';
    export let monitoringResults, systemData;
</script>

<h3 style="margin-bottom: 0.2em;">Source water average contaminant levels</h3>
<p class="text">Providers can get their water from one or many sources. Most pump groundwater from wells but some use surface water.</p>
<div class="key" aria-hidden="true">
    <div><b class="no-results"></b>No results</div>
    <div><b class="max"></b>Maximum contaminant level</div>
    <div><b class="goal"></b>Public health goal</div>
</div>
<div class="row bottom">
    <div class="chart-group">
        <h4  aria-label="Bar chart of arsenic source levels. The maximum contaminant level for arsenic is 10 parts per billion. The public health goal is 0.004 parts per billion">Arsenic <span class='unit'>in parts per billion</span></h4>
        <ResultsChart {monitoringResults} tests = 1 analyte = 'arsenic'/>
    </div>
    <div class="chart-group">
        <h4  aria-label="Bar chart of nitrate source levels. The maximum contaminant level for nitrate is 10 parts per million. The public health goal is also 10 parts per million">Nitrate <span class='unit'>in parts per million</span></h4>
        <ResultsChart {monitoringResults} tests = 1 analyte = 'nitrate'/>
    </div>
    <div class="chart-group">
        <h4  aria-label="Bar chart of 1,2,3-TCP source levels. The maximum contaminant level for 1,2,3-TCP is 5 parts per trillion. The public health goal is 0.07 parts per trillion">1,2,3-TCP <span class='unit'>in parts per trillion</span></h4>
        <ResultsChart {monitoringResults} tests = 1 analyte = 'tcp'/>
    </div>
</div>

{#if systemData.arsenic_treated >= 1 | systemData.nitrate_treated >= 1 | systemData.tcp_treated >= 1}
<h3 style="margin-bottom: 0.2em;">Treated water average contaminant levels</h3>
<p class="text">This provider works to remove contamination from some or all of its source water through treatment before it is sent to customers.</p>
<div class="key" aria-hidden="true">
    <div><b class="no-results"></b>No results</div>
    <div><b class="max"></b>Maximum contaminant level</div>
    <div><b class="goal"></b>Public health goal</div>
</div>
<div class="row bottom"  style="margin-top: 0;">
    <div class="chart-group">
        <h4 aria-label="Bar chart of arsenic treated levels. The maximum contaminant level for arsenic is 10 parts per billion. The public health goal is 0.004 parts per billion">Arsenic <span class='unit'>in parts per billion</span></h4>
        <ResultsChart {monitoringResults} tests = {systemData.arsenic_treated} analyte = 'arsenic_treated'/>
    </div>
    <div class="chart-group">
        <h4 aria-label="Bar chart of nitrate treated levels. The maximum contaminant level for nitrate is 10 parts per million. The public health goal is also 10 parts per million">Nitrate <span class='unit'>in parts per million</span></h4>
        <ResultsChart {monitoringResults} tests = {systemData.nitrate_treated} analyte = 'nitrate_treated'/>
    </div>
    <div class="chart-group">
        <h4 aria-label="Bar chart of 1,2,3-TCP treated levels. The maximum contaminant level for 1,2,3-TCP is 5 parts per trillion. The public health goal is 0.07 parts per trillion">1,2,3-TCP <span class='unit'>in parts per trillion</span></h4>
        <ResultsChart {monitoringResults} tests = {systemData.tcp_treated} analyte = 'tcp_treated'/>
    </div>
</div>
{/if}